'use strict';

var modelFilters = function () {
  var categories = ['vmotor', 'vgrado', 'vtipoTransmision', 'vtraccion', 'vcolor'];

  var completeList = void 0,
      filters = {},
      filtersValues = {};

  var _setCompleteList = function _setCompleteList(value) {
    return completeList = value;
  };
  var _getCompleteList = function _getCompleteList() {
    return completeList;
  };

  var _buildFilterLists = function _buildFilterLists(vehicles) {
    _setCompleteList(vehicles);
    categories.forEach(function (category) {
      return _makeFiltersObj(vehicles, category);
    });
    _fillFiltersSelects();
  };

  var _makeFiltersObj = function _makeFiltersObj(vehicles, category) {
    var uniques = [];
    var results = vehicles.map(function (elem) {
      if (uniques.indexOf(elem.vehicle[category]) === -1) {
        uniques.push(elem.vehicle[category]);
        var result = {};
        result.value = elem.vehicle[category];
        if (category === 'vmotor') {
          result.option = elem.vehicle[category] + ' ' + elem.vehicle.vcombustible;
          return result;
        } else if (category === 'vcolor') {
          result.option = elem.vehicle[category] + ' (' + elem.vehicle.vtipoColor + ')';
          return result;
        } else if (category === 'vtipoTransmision') {
          if (elem.vehicle[category] === 'automática') {
            result.option = utilsVVS.capitalize(elem.vehicle[category]) + ' (CVT / DCT)';
            return result;
          }
          result.option = utilsVVS.capitalize(elem.vehicle[category]);
          return result;
        } else {
          result.option = elem.vehicle[category];
          return result;
        }
      }
    });
    results = results.filter(function (elem) {
      return typeof elem !== 'undefined';
    });
    filters[category] = results;
  };

  var _fillFiltersSelects = function _fillFiltersSelects() {
    var _loop = function _loop(prop) {
      var $selectNode = $('.js-select[data-category=' + prop + ']');
      filters[prop] = utilsVVS.sortArrayOfObjects(filters[prop], 'option');
      filters[prop].forEach(function (item) {
        var $option = $('<option/>').val(item.value).text(item.option);
        $selectNode.append($option);
      });
      $selectNode.on('change', function () {
        _filterVehiclesList($(this).val(), $(this).data('category'));
      });
    };

    for (var prop in filters) {
      _loop(prop);
    }
  };

  var _filterVehiclesList = function _filterVehiclesList(value, category) {
    filtersValues[category] = value;

    var filteredList = _getCompleteList();

    var _loop2 = function _loop2(property) {
      if (filtersValues[property] !== '') {
        filteredList = filteredList.filter(function (elem) {
          return elem.vehicle[property] === filtersValues[property];
        });
      }
    };

    for (var property in filtersValues) {
      _loop2(property);
    }
    console.log('calling print filtered list');
    modelVVS.print(filteredList);
  };

  return {
    buildFilterLists: _buildFilterLists
  };
}();